import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { t } from '../../../domain/services/configService';
import { theme } from '../../../domain/theme';
// import { stripTags, truncateText } from '../../../domain/utils/stringUtils';
import { Actionable } from '../atoms/Actionable';
import { facePaint } from '../../../domain/theme/utils/facePaint';

export const ReadMoreByLines = ({ text, maxLines }) => {
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current.offsetHeight < ref.current.scrollHeight) {
      setIsEllipsisActive(true);
    }
  }, []);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const styles = {
    text: css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      ${!isOpen &&
      facePaint({
        '-webkit-line-clamp': Object.values(maxLines)
      })}
    `,
    actionable: css`
      ${theme.font.family('medium')};
      color: #999;
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 3px;
      &:hover {
        text-decoration: underline;
      }
    `
  };

  const actionableTitle = t(isOpen ? 'Show less' : 'Read More');

  return (
    <p>
      <span
        css={styles.text}
        ref={ref}
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {isEllipsisActive && (
        <>
          {' '}
          <Actionable
            title={actionableTitle}
            onClick={toggleOpen}
            display="inline-block"
          >
            <span css={styles.actionable}>{actionableTitle}</span>
          </Actionable>
        </>
      )}
    </p>
  );
};

ReadMoreByLines.propTypes = {
  text: PropTypes.string.isRequired,
  maxLines: PropTypes.shape({
    mobile: PropTypes.number,
    tablet: PropTypes.number,
    small_desktop: PropTypes.number,
    large_desktop: PropTypes.number
  }).isRequired
};
